/*LIBRARY*/
import {
  useState,
  // useEffect
} from "react";
import { connect } from "react-redux";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Title,
  SubTitle,
} from "chart.js";
import { Chart } from "react-chartjs-2";
import "chartjs-adapter-luxon";

/*COMPONENT*/
import Modal from "../common_modal/Modal";

/*REDUX*/
import {
  set_item_on_layer,
  view_layer,
  filter_isi_layer,
  reset_filter,
} from "../../App/actions/dataActions";
import { set_value_layer } from "../../App/actions/layerActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Title,
  SubTitle,
);

const CHART_DATE = ({
  layer,
  map,
  auth,
  field_date,
  set_value_layer,
  filter_isi_layer,
  reset_filter,
}) => {
  const [startdate, setStartdate] = useState("");
  const [enddate, setEnddate] = useState("");
  const [modal_chart_fullscreen, setModal_chart_fullscreen] = useState(false);
  const [data_state, set_data_state] = useState([]);
  const [time_unit, set_time_unit] = useState("day");

  const toggleChartFulscreen = () => {
    setModal_chart_fullscreen(!modal_chart_fullscreen);
  };

  const on_set_mode_chart = (mode) => {
    const { layer_id, geo_layer_list } = layer;
    const layer_item = geo_layer_list.find((l) => l.geo_layer._id === layer_id);
    const field_key = field_date.key;
    const features = layer_item?.geo_layer?.geojson?.features;

    // Safety check if features exist
    if (!features) {
      set_data_state([]);
      return;
    }

    const raw_array = features
      .map((item) => item?.properties?.[field_key])
      .filter((d) => {
        // Fix: Prevent invalid date strings from entering the array
        if (!d) return false;
        const testDate = new Date(d);
        return !isNaN(testDate.getTime());
      });

    if (raw_array.length === 0) {
      set_data_state([]);
      return;
    }
    const dates = raw_array.map((d) => new Date(d));
    const early_date = new Date(Math.min(...dates));
    const last_date = new Date(Math.max(...dates));
    let chartData = [];
    let timeUnit = "day";

    if (mode === "10") {
      const sortedDates = raw_array
        .sort((a, b) => new Date(b) - new Date(a))
        .slice(0, 10);
      const dayCounts = {};
      sortedDates.forEach((date) => {
        dayCounts[date] = (dayCounts[date] || 0) + 1;
      });
      chartData = Object.keys(dayCounts)
        .sort((a, b) => new Date(a) - new Date(b))
        .map((date) => {
          const startDate = new Date(date);
          const endDate = new Date(date);
          return {
            x: date,
            y: dayCounts[date],
            start_date: startDate.getTime(),
            end_date: endDate.getTime(),
            range_type: "day",
          };
        });
      timeUnit = "day";
    } else if (mode === "month") {
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
      const filteredDates = raw_array.filter(
        (date) => new Date(date) >= oneMonthAgo,
      );
      const dayCounts = {};
      filteredDates.forEach((date) => {
        dayCounts[date] = (dayCounts[date] || 0) + 1;
      });
      chartData = Object.keys(dayCounts)
        .sort((a, b) => new Date(a) - new Date(b))
        .map((date) => {
          const startDate = new Date(date);
          const endDate = new Date(date);
          return {
            x: date,
            y: dayCounts[date],
            start_date: startDate.getTime(),
            end_date: endDate.getTime(),
            range_type: "day",
          };
        });
      timeUnit = "day";
    } else if (mode === "6_months") {
      const sixMonthsAgo = new Date();
      sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
      const filteredDates = raw_array.filter(
        (date) => new Date(date) >= sixMonthsAgo,
      );
      const monthCounts = {};
      filteredDates.forEach((date) => {
        const yearMonth = date.substring(0, 7) + "-01";
        monthCounts[yearMonth] = (monthCounts[yearMonth] || 0) + 1;
      });
      chartData = Object.keys(monthCounts)
        .sort((a, b) => new Date(a) - new Date(b))
        .map((date) => {
          const startDate = new Date(date);
          const endDate = new Date(date);
          endDate.setMonth(endDate.getMonth() + 1);
          return {
            x: date,
            y: monthCounts[date],
            start_date: startDate.getTime(),
            end_date: endDate.getTime(),
            range_type: "month",
          };
        });
      timeUnit = "month";
    } else if (mode === "year") {
      const oneYearAgo = new Date();
      oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
      const filteredDates = raw_array.filter(
        (date) => new Date(date) >= oneYearAgo,
      );
      const monthCounts = {};
      filteredDates.forEach((date) => {
        const yearMonth = date.substring(0, 7) + "-01";
        monthCounts[yearMonth] = (monthCounts[yearMonth] || 0) + 1;
      });
      chartData = Object.keys(monthCounts)
        .sort((a, b) => new Date(a) - new Date(b))
        .map((date) => {
          const startDate = new Date(date);
          const endDate = new Date(date);
          endDate.setMonth(endDate.getMonth() + 1);
          return {
            x: date,
            y: monthCounts[date],
            start_date: startDate.getTime(),
            end_date: endDate.getTime(),
            range_type: "month",
          };
        });
      timeUnit = "month";
    } else if (mode === "all") {
      reset_filter({ geo_layer_id: layer_id });

      const diffTime = Math.abs(last_date - early_date);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays <= 31) {
        const dayCounts = {};
        raw_array.forEach((date) => {
          dayCounts[date] = (dayCounts[date] || 0) + 1;
        });
        chartData = Object.keys(dayCounts)
          .sort((a, b) => new Date(a) - new Date(b))
          .map((date) => {
            const startDate = new Date(date);
            const endDate = new Date(date);
            return {
              x: date,
              y: dayCounts[date],
              start_date: startDate.getTime(),
              end_date: endDate.getTime(),
              range_type: "day",
            };
          });
        timeUnit = "day";
      } else {
        const monthCounts = {};
        raw_array.forEach((date) => {
          const yearMonth = date.substring(0, 7) + "-01";
          monthCounts[yearMonth] = (monthCounts[yearMonth] || 0) + 1;
        });
        chartData = Object.keys(monthCounts)
          .sort((a, b) => new Date(a) - new Date(b))
          .map((date) => {
            const startDate = new Date(date);
            const endDate = new Date(date);
            endDate.setMonth(endDate.getMonth() + 1);
            return {
              x: date,
              y: monthCounts[date],
              start_date: startDate.getTime(),
              end_date: endDate.getTime(),
              range_type: "month",
            };
          });
        timeUnit = "month";
      }
    }
    set_data_state(chartData);
    set_time_unit(timeUnit);
    set_value_layer({
      key: "mode_chart",
      value: mode,
    });
  };

  // // --- NEW COMPONENT DID MOUNT EFFECT ---
  // useEffect(() => {
  //   // This triggers the data generation and sets the mode to "all" immediately on load.
  //   on_set_mode_chart("all");
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  // // --------------------------------------

  const on_click_chart = (e, d) => {
    if (!d || d.length === 0) {
      return;
    }

    if (!d[0]?.element?.$context?.raw) {
      return;
    }

    try {
      const data = d[0].element.$context.raw;
      const { layer_id } = layer;
      const field_key = field_date.key;
      const start_date = data.start_date;
      const end_date = data.end_date;

      // Fix: check for valid dates before ISO conversion
      if (
        isNaN(new Date(start_date).getTime()) ||
        isNaN(new Date(end_date).getTime())
      )
        return;

      const start_date_html = new Date(start_date).toISOString().split("T")[0];
      const end_date_html = new Date(end_date).toISOString().split("T")[0];
      setStartdate(start_date_html);
      setEnddate(end_date_html);
      const body = {
        geo_layer_id: layer_id,
        start_date,
        end_date,
        field_key,
        time_mode: "unix",
      };
      filter_isi_layer(body);
    } catch (error) {
      console.error("Error setting chart click range: ", error);
    }
  };

  const on_change = (e) => {
    const { name, value } = e.target;
    if (name === "startdate") {
      setStartdate(value);
    } else if (name === "enddate") {
      setEnddate(value);
    }
  };

  const on_submit = (event) => {
    event.preventDefault();
    const { layer_id } = layer;
    const field_key = field_date.key;
    if (startdate && enddate) {
      let startDateObj = new Date(startdate);
      let endDateObj = new Date(enddate);

      // Fix: Safety check before parsing to ISO
      if (isNaN(startDateObj.getTime()) || isNaN(endDateObj.getTime())) return;

      startDateObj.setDate(startDateObj.getDate());
      endDateObj.setDate(endDateObj.getDate());
      let startdt = startDateObj.toISOString().split("T")[0];
      let enddt = endDateObj.toISOString().split("T")[0];
      const body = {
        geo_layer_id: layer_id,
        start_date: startdt,
        end_date: enddt,
        field_key,
        time_mode: "string",
      };
      filter_isi_layer(body);
    }
  };

  const language = localStorage?.language || auth.language;
  const { mode_chart } = map;

  const optionsBar = {
    onClick: on_click_chart,
    animation: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          afterLabel: function (context) {
            const raw = context.raw;
            if (raw.range_type) {
              const start = new Date(raw.start_date);
              const end = new Date(raw.end_date);
              if (raw.start_date === raw.end_date) {
                return `Date: ${start.toLocaleDateString()}`;
              }
              return `Range: ${start.toLocaleDateString()} - ${end.toLocaleDateString()}`;
            }
            return "";
          },
        },
      },
    },
    maintainAspectRatio: true,
    aspectRatio: 1,
    responsive: true,
    scales: {
      x: {
        type: "time",
        time: {
          unit: time_unit,
          displayFormats: {
            day: "MMM dd",
            month: "MMM yyyy",
          },
          tooltipFormat: "MMM dd, yyyy",
        },
        title: {
          display: true,
          text: dict?.["Time/date"]?.[language],
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: dict?.["Amount of Data"]?.[language],
        },
        display: true,
      },
    },
  };

  const data = {
    datasets: [
      {
        data: data_state,
        label: dict?.["Amount of Data"]?.[language],
        backgroundColor: data_state.map((d) => {
          // Fix: Wrap in try/catch and validate dates to prevent rendering crashes
          try {
            const startDt = new Date(d.start_date);
            const endDt = new Date(d.end_date);

            if (isNaN(startDt.getTime()) || isNaN(endDt.getTime())) {
              return "#3d3f92";
            }

            const start_html = startDt.toISOString().split("T")[0];
            const end_html = endDt.toISOString().split("T")[0];

            if (startdate === start_html && enddate === end_html) {
              return "#000"; // Highlight selected bar black
            }
            return "#3d3f92"; // Default color
          } catch (e) {
            return "#3d3f92";
          }
        }),
        hoverBackgroundColor: "#8fcc1bff",
        borderColor: "#ffcd2c",
        lineTension: 0.2,
      },
    ],
  };

  const modalChartFullscreen = modal_chart_fullscreen && (
    <Modal
      modalSize="large"
      id="modal"
      isOpen={modal_chart_fullscreen}
      onClose={(params) => toggleChartFulscreen(params)}
    >
      <div className="box-body">
        <main className="max_height">
          <h1 className="text_header margin_bottom">Detail</h1>
          <div style={{ maxHeight: "calc(100vh - 220px)" }}>
            {data_state.length > 0 ? (
              <Chart
                type="bar"
                data={data}
                options={{
                  ...optionsBar,
                  maintainAspectRatio: false,
                  responsive: true,
                }}
                style={{ width: "100%", height: "100%" }}
              />
            ) : (
              <p>No data available</p>
            )}
          </div>
        </main>
      </div>
    </Modal>
  );

  return (
    <main className="container margin_bottom background_grey_light">
      {modalChartFullscreen}

      <h1 className="text_bold margin_bottom">
        {dict["Grouping by"][language]} {field_date?.name}
      </h1>

      <section>
        <button
          className={`button_small outline_black margin_right margin_bottom ${
            mode_chart === "10" ? "background_black" : "button_white"
          }`}
          onClick={() => on_set_mode_chart("10")}
        >
          {dict?.["10 Latest"]?.[language]}
        </button>
        <button
          className={`button_small outline_black margin_right margin_bottom ${
            mode_chart === "month" ? "background_black" : "button_white"
          }`}
          onClick={() => on_set_mode_chart("month")}
        >
          {dict?.["1 month"]?.[language]}
        </button>
        <button
          className={`button_small outline_black margin_right margin_bottom ${
            mode_chart === "6_months" ? "background_black" : "button_white"
          }`}
          onClick={() => on_set_mode_chart("6_months")}
        >
          {dict?.["6 months"]?.[language]}
        </button>
        <button
          className={`button_small outline_black margin_right margin_bottom ${
            mode_chart === "year" ? "background_black" : "button_white"
          }`}
          onClick={() => on_set_mode_chart("year")}
        >
          {dict?.["1 year"]?.[language]}
        </button>
        <button
          className={`button_small outline_black margin_right margin_bottom ${
            mode_chart === "all" ? "background_black" : "button_white"
          }`}
          onClick={() => on_set_mode_chart("all")}
        >
          {dict?.["All"]?.[language]}
        </button>
      </section>

      <section>
        <div style={{ width: "100%", textAlign: "end" }}>
          <button
            onClick={() => {
              toggleChartFulscreen();
            }}
            className="button_small background_black margin_bottom"
            disabled={data_state.length === 0}
          >
            {dict?.["Full screen"]?.[language]}
          </button>
        </div>
        <section className="container background_white margin_bottom">
          {data_state.length > 0 ? (
            <Chart
              type="bar"
              data={data}
              options={optionsBar}
              width={100}
              height={100}
            />
          ) : (
            <p style={{ padding: "20px", textAlign: "center" }}>
              No data available. Please select a time period.
            </p>
          )}
        </section>

        <section>
          <p className="text_medium sub_color margin_bottom">Start</p>
          <input
            placeholder={dict["Select Start Date"][language]}
            type="date"
            name="startdate"
            id="startdate"
            value={startdate}
            onChange={on_change}
            className="margin_bottom"
          />

          <p className="text_medium sub_colo margin_bottom">End</p>

          <input
            placeholder={dict["Select End Date"][language]}
            type="date"
            name="enddate"
            id="enddate"
            value={enddate}
            onChange={on_change}
            className="margin_bottom"
          />

          <button className="button background_black" onClick={on_submit}>
            {dict?.["Date filter"]?.[language]}
          </button>
        </section>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  map: state.map,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  set_item_on_layer,
  view_layer,
  set_value_layer,
  filter_isi_layer,
  reset_filter,
})(CHART_DATE);
